<template>
    <div>
        <!-- Modal Conta -->
        <div class="modal fade" id="contaModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-xl modal-dialog-scrollable" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Lançamentos / Conta</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">

                        <template v-if="dados && dados.lancamentos">

                            <div v-if="dados && dados.internacao && dados.internacao.paciente" class="alert alert-secondary d-flex justify-content-between">
                                <div>
                                    <strong>{{ dados.internacao.paciente.st_nome }}</strong>
                                </div>
                                <div>
                                    #{{ dados.internacao.id_internacao }}
                                </div>
                            </div>

                            <ul class="nav nav-tabs" id="myTab" role="tablist">
                                <li class="nav-item" role="presentation">
                                    <a class="nav-link active" id="home-tab" data-toggle="tab" href="#home" role="tab" aria-controls="home" aria-selected="true">Lançamentos</a>
                                </li>
                                <li class="nav-item" role="presentation" v-if="dados && dados.guias && dados.guias.length">
                                    <a class="nav-link" id="profile-tab" data-toggle="tab" href="#profile" role="tab" aria-controls="profile" aria-selected="false">Guias</a>
                                </li>
                            </ul>


                            <div class="tab-content" id="myTabContent">
                                <!-- Lançamentos -->
                                <div class="tab-pane fade show active" id="home" role="tabpanel" aria-labelledby="home-tab">
                                    
                                    <div class="form-row my-3">
                                        <div class="col col-12 col-md-8">
                                            <az-periodo v-model="filtros" :sync="true" @sync="refresh()" />
                                        </div>
                                        <div class="col col-12 col-md-4">
                                            <az-input 
                                                type="checkbox-group"
                                                label="Exibir itens zerados"
                                                v-model="exibe_zerados">
                                                <template v-slot:buttonposcb>
                                                    <div class="input-group-append">
                                                        <button class="btn btn-outline-primary btn-sm" @click="imprimir()">
                                                            <i class="fa-solid fa-print"></i>
                                                        </button>
                                                        <button class="btn btn-outline-primary btn-sm" @click="agrupar_cc = !agrupar_cc; refresh();" v-if="dados && dados.por_centro_custo">
                                                            <i class="fa-solid fa-location-dot-slash fa-fw" v-if="!agrupar_cc"></i>
                                                            <i class="fa-solid fa-location-dot fa-fw" v-else></i>
                                                        </button>
                                                    </div>
                                                </template>
                                            </az-input>
                                        </div>
                                    </div>

                                    <div v-if="dados && dados.lancamentos" id="impressao-lancamentos">

                                        <cabecalho-generico titulo="Lançamentos">
                                            <div>
                                                Paciente: {{ dados.internacao.paciente.st_nome }}
                                            </div>
                                            <div>
                                                Internação: #{{ dados.internacao.id_internacao }}
                                            </div>
                                            <div>
                                                Admissão: {{ $util.getFormatDate(dados.internacao.dt_admissao) }} <span v-if="dados.internacao.st_hora_admissao">{{ dados.internacao.st_hora_admissao }}</span>
                                            </div>
                                            <div v-if="dados.internacao.dt_alta && dados.internacao.st_hora_alta">
                                                Alta: {{ dados.internacao.dt_alta ? $util.getFormatDate(dados.internacao.dt_alta) : 'Hoje' }}
                                                <span v-if="dados.internacao.dt_alta && dados.internacao.st_hora_alta">{{ dados.internacao.st_hora_alta }}</span>
                                            </div>
                                            <div v-if="dados.periodo && dados.periodo.inicio && dados.periodo.fim">
                                                Periodo: {{ $util.getFormatDate(dados.periodo.inicio) }} - {{ $util.getFormatDate(dados.periodo.fim) }}
                                            </div>
                                            <div v-if="dados.internacao.plano.id_operadora > 1">
                                                <div v-if="dados.internacao.plano.operadora.fl_sus">
                                                    CPF: {{ dados.internacao.paciente.cadastro.st_cpf }} 
                                                    <span v-if="dados.internacao.paciente.paciente_unidade.st_sus"> / CNS: {{ dados.internacao.paciente.paciente_unidade.st_sus }}</span>
                                                </div>
                                                <div v-else-if="dados.internacao.st_numero_carteira">
                                                    Matrícula: {{ dados.internacao.st_numero_carteira }}
                                                </div>
                                            </div>
                                        </cabecalho-generico>
                                            
                                        <div v-for="(plano_items, plano, ipx) in dados.lancamentos" :key="ipx" class="mb-4">
                                            <div class="alert alert-info d-flex justify-content-between">
                                                <div>
                                                    <strong>{{ plano }}</strong>
                                                </div>
                                                <div v-if="plano && plano.toUpperCase().startsWith('PARTICULAR')">
                                                    <a href="#" @click.prevent="pagamento(plano_items)" class="card-link">
                                                        Pagamento: {{ $util.formatMoeda(totalizar(plano_items, 'valor_pag', true)) }}
                                                    </a>
                                                </div>
                                                <div>
                                                    <strong>{{ $util.formatMoeda(totalizar(plano_items, 'valor', true)) }}</strong>
                                                </div>
                                            </div>

                                            <table class="table table-sm table-striped">
                                                <thead>
                                                    <tr>
                                                        <th></th>
                                                        <th>Código</th>
                                                        <th>Descrição</th>
                                                        <th v-if="dados.por_centro_custo">CC</th>
                                                        <th class="text-right">Qtd</th>
                                                        <th class="text-right">Valor</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <template v-for="(lista, tipo, idx) in plano_items">
                                                        <tr :key="'tipo' + idx" v-if="true" class="table-secondary">
                                                            <th :colspan="dados.por_centro_custo ? 5 : 4"><strong>{{ traduzir_tipo(tipo) }}</strong></th>
                                                            <th class="text-right">
                                                                <strong>{{ $util.formatMoeda(totalizar(lista, 'valor')) }}</strong>
                                                            </th>
                                                        </tr>
                                                        <template v-for="(item, iix) in lista">
                                                            <template v-if="exibe_zerados || item.valor > 0">
                                                                <tr :key="'item-' + idx + '-' + iix">
                                                                    <td width="1%">
                                                                        <a href="#" @click.prevent="item.aberto = !item.aberto" class="d-print-block">
                                                                            <i class="fa-regular fa-square-minus" v-if="item.aberto"></i>
                                                                            <i class="fa-regular fa-square-plus" v-else></i>
                                                                        </a>
                                                                    </td>
                                                                    <td>
                                                                        {{ item.codigo }}
                                                                        <i class="fa-solid fa-box-archive ml-2" v-if="item.empacotado"></i>
                                                                    </td>
                                                                    <td>{{ item.descricao }}</td>
                                                                    <td v-if="dados.por_centro_custo">
                                                                        {{ item.centro ? ( item.centro.st_sigla ? item.centro.st_sigla : item.centro.st_nome ) : '' }}
                                                                    </td>
                                                                    <td class="text-right">{{ item.quantidade }}</td>
                                                                    <td class="text-right" :class="item.empacotado ? 'text-muted' : ''">{{ $util.formatMoeda(item.valor) }}</td>
                                                                </tr>
                                                                <tr :key="'lista' + iix" v-if="item.aberto">
                                                                    <td :colspan="dados.por_centro_custo ? 6 : 5" class="p-3">
                                                                        <table class="table table-sm table-hover">
                                                                            <thead>
                                                                                <tr>
                                                                                    <th>Atend</th>
                                                                                    <th>Data</th>
                                                                                    <th>Profissional</th>
                                                                                    <th class="text-right">Qtd</th>
                                                                                    <th class="text-right">Valor</th>
                                                                                </tr>
                                                                            </thead>
                                                                            <tr v-for="(item_lista, ili) in item.lista" :key="'detalhe' + ili">
                                                                                <td>
                                                                                    <span v-if="!editar_atend">
                                                                                        #{{ item_lista.id_atendimento }}
                                                                                    </span>
                                                                                    <a href="#" @click="editar_atend(item_lista.id_atendimento)" class="card-link" v-else>
                                                                                        #{{ item_lista.id_atendimento }}
                                                                                    </a>
                                                                                    <i class="fa-solid fa-box-archive ml-2" v-if="item_lista.id_atendimento_procedimento_empacotado"></i>

                                                                                    <template v-if="item_lista.pag">
                                                                                        <i class="fa fa-check-circle text-success ml-2" aria-hidden="true" title="Pago"></i>
                                                                                    </template>
                                                                                </td>
                                                                                <td>
                                                                                    {{ $util.getFormatDate(item_lista.data) }}
                                                                                    {{ item_lista.data.slice(11,16) }}
                                                                                </td>
                                                                                <td>
                                                                                    {{ item_lista.medico ? item_lista.medico.st_nome_exibicao : '' }}
                                                                                </td>
                                                                                <td class="text-right">{{ item_lista.quantidade }}</td>
                                                                                <td class="text-right">{{ $util.formatMoeda(item_lista.valor) }}</td>
                                                                            </tr>
                                                                        </table>
                                                                    </td>
                                                                </tr>
                                                            </template>
                                                        </template>
                                                    </template>
                                                </tbody>
                                                <tfoot v-if="false">
                                                    <tr class="table-info">
                                                        <th colspan="4">Total:</th>
                                                        <th class="text-right">
                                                            {{ $util.formatMoeda(totalizar(plano_items, 'valor', true)) }}
                                                        </th>
                                                    </tr>
                                                </tfoot>
                                            </table>
                                        </div>
                                    </div>

                                </div>

                                <!-- Guias -->
                                <div class="tab-pane fade" id="profile" role="tabpanel" aria-labelledby="profile-tab" v-if="dados && dados.guias">
                                    <div class="mt-3">

                                        <div class="mb-1" v-if="dados.guias.length > 1">

                                            <div class="form-row">

                                                <div class="col col-12 col-md-6">
                                                    <az-input 
                                                        icon="fa fa-search fa-fw"
                                                        sizing="sm"
                                                        placeholder="Pesquisar..."
                                                        v-model="search_guias" />
                                                </div>

                                                <div class="col col-12 col-md-5">

                                                    <template v-if="!unificando_guias">
                                                        <button type="button" class="btn btn-sm btn-outline-primary" @click="unificando_guias = true">Unificar</button>
                                                    </template>

                                                    <template v-else>
                                                        <button type="button" class="btn btn-sm btn-outline-primary mr-1" @click="toggle_marcar_guias()">Todas</button>
                                                        <button type="button" class="btn btn-sm btn-primary mr-1" @click="confirmar_unificacao()">Confirmar Unificação</button>
                                                        <button type="button" class="btn btn-sm btn-outline-danger" @click="unificando_guias = false">Cancelar Unificação</button>
                                                    </template>

                                                </div>

                                                <div class="col col-12 col-md-1 text-right">
                                                    {{ guias_selecionadas.length }}/{{ guias_filtradas.length }}
                                                </div>

                                            </div>

                                            <template v-if="guia_tipos.length > 1">
                                                <table class="table table-sm border-0 table-responsive">
                                                    <tr>
                                                        <td class="text-nowrap">
                                                            <a href="#" @click.prevent="filtrar_guia(tipo)" v-for="(tipo, icx) in guia_tipos" :key="icx">
                                                                <span class="badge badge-success mr-1" >
                                                                    {{ tipo }}
                                                                </span>
                                                            </a>
                                                        </td>
                                                    </tr>
                                                </table>
                                            </template>

                                        </div>

                                        <table class="table table-sm small table-hover">
                                            <thead>
                                                <tr>
                                                    <th v-if="unificando_guias"></th>
                                                    <th>Guia</th>
                                                    <th>Número</th>
                                                    <th>Data</th>
                                                    <th>Início</th>
                                                    <th>Fim</th>
                                                    <th>Contrato</th>
                                                    <th>#</th>
                                                    <th></th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="(guia, igx) in guias_filtradas" :key="igx">
                                                    <td v-if="unificando_guias">
                                                        <input type="checkbox" v-if="unificando_guias" :disabled="guia.ch_status != 'DI'" class="mr-2" v-model="guia.selected">    
                                                    </td>
                                                    <td>
                                                        <span class="badge mr-2" :class="'badge-' + guia.status_color">{{ guia.ch_status }}</span>
                                                        <a href="#" @click.prevent="abrir_guia(guia)" class="card-link">
                                                            {{ guia.nome }}
                                                        </a>
                                                    </td>
                                                    <td>
                                                         {{ guia.guia_formatada }}
                                                    </td>
                                                    <td>
                                                        {{ $util.getFormatDate(guia.data_guia) }}
                                                    </td>
                                                    <td>
                                                        {{ $util.getFormatDate(guia.dt_inicio_fat) }}
                                                    </td>
                                                    <td>
                                                        {{ $util.getFormatDate(guia.dt_fim_fat) }}
                                                    </td>
                                                    <td>
                                                        <span v-if="guia.contrato_operadora">
                                                            {{ guia.contrato_operadora.search }}
                                                        </span>
                                                    </td>
                                                    <td>
                                                        #{{ guia.id_atendimento }}
                                                    </td>
                                                    <td class="text-right">
                                                        <a href="#" @click.prevent="imprimir_espelho_guia(guia)" class="ml-3">
                                                            <i class="fa fa-print" aria-hidden="true"></i>
                                                        </a>
                                                    </td>
                                                </tr>
                                            </tbody>

                                        </table>

                                        <ul class="list-group" v-if="false">
                                            <li class="list-group-item d-flex justify-content-between" v-for="(guia, igx) in guias_filtradas" :key="igx">
                                                <div>
                                                    <input type="checkbox" v-if="unificando_guias" :disabled="guia.ch_status != 'DI'" class="mr-2" v-model="guia.selected">

                                                    <a href="#" @click.prevent="abrir_guia(guia)" class="card-link">
                                                        Guia {{ guia.nome }} {{ guia.guia_formatada }} - {{ $util.getFormatDate(guia.data_guia) }}
                                                    </a>
                                                        
                                                    <span class="badge ml-2" :class="'badge-' + guia.status_color">{{ guia.ch_status }}</span>

                                                    <div v-if="guia.contrato_operadora" class="small text-muted ml-3">
                                                        {{ guia.contrato_operadora.search }}
                                                    </div>
                                                </div>
                                                <div>
                                                    #{{ guia.id_atendimento }}

                                                    <a href="#" @click.prevent="imprimir_espelho_guia(guia)" class="ml-3">
                                                        <i class="fa fa-print" aria-hidden="true"></i>
                                                    </a>
                                                </div>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>

                        </template>

                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                    </div>
                </div>
            </div>
        </div>

        <guia-edicao ref="guia" :viewonly="false" v-if="!emit_guia" />
    </div>
</template>

<script>
import _ from 'lodash';
import $ from 'jquery'; 
import AzInput from '../../shared/forms/AzInput.vue';
import CabecalhoGenerico from '../../relatorios/shared/CabecalhoGenerico.vue';
import GuiaEdicao from '../faturamento/GuiaEdicao.vue';
import AzPeriodo from '../../shared/forms/AzPeriodo.vue';

export default {
    data() {
        return { 
            dados: null, 
            exibe_zerados: false, 
            filtros: { 
                periodo: "", 
            },
            agrupar_cc: false, 
            unificando_guias: false, 
            search_guias: "", 
        };
    },

    components: { 
        AzInput,
        CabecalhoGenerico, 
        GuiaEdicao, 
        AzPeriodo,
    },

    props: ['editar_atend', 'emit_guia'],

    computed: { 
        guias_filtradas: function() { 
            if ( !this.dados || !this.dados.guias ) { 
                return [];
            }

            if ( !this.search_guias ) { 
                return this.dados.guias;
            }

            let reg = this.$util.getregex(this.search_guias);

            return this.dados.guias.filter(item => !this.search_guias || reg.test(JSON.stringify(item)));
        },

        guias_selecionadas () { 
            return this.guias_filtradas.filter(guia => guia.selected);
        }, 

        guia_tipos: function() { 
            if ( !this.dados || !this.dados.guias ) { 
                return [];
            }

            return _.uniq(this.dados.guias.map(g => g.nome)).sort();
        }
    },

    methods: { 
        filtrar_guia (tipo) { 
            if ( this.search_guias == '"' + tipo + '"' ) {
                this.search_guias = ""; 
            } else { 
                this.search_guias = '"' + tipo + '"'; 
            }
        },

        confirmar_unificacao () { 
            this.$util.atualizar(this, { 
                service: 'guias', 
                func: 'unificar_guias',
                dados: { 
                    id_guias: this.guias_selecionadas.map(g => g.id_guia)
                },
                toast: true, 
                callback: () => { 
                    this.unificando_guias = false; 
                    this.refresh(); 
                }
            });
        },

        toggle_marcar_guias () { 
            let tem_desmarcada = this.dados.guias.find(guia => guia.ch_status == 'DI' && !guia.selected);

            this.dados.guias.forEach(guia => { 
                if ( guia.ch_status == 'DI' ) { 
                    guia.selected = tem_desmarcada ? true : false; 
                }
            });
        },

        refresh() { 
            this.abrir(this.dados.internacao.id_internacao, this.filtros);
        },

        imprimir_espelho_guia (guia) { 
            this.$util.print_preview('imprimir/espelho_guia/' + guia.id_guia, true, { noass: 1 }, true);  
        }, 

        pagamento (itens) { 
            let ids = _.uniq(
                _.flatMap(itens, item => { 
                    return _.flatMap(item, subitem => { 
                        return subitem.id_atd ? subitem.id_atd : []
                    });
                })
            );

            if ( !ids || !ids.length ) { 
                this.$toast.add({ 
                    severity: 'warn', 
                    summary: 'Pagamento', 
                    detail: 'Não há itens para pagamento',
                })
                return; 
            }

            $('.modal').modal('hide');

            this.$router.push({ name: 'pagamentos', params: { idpaciente: this.dados.internacao.id_paciente, id_atds: ids } });
        },

        abrir_guia (guia) { 
            $('#contaModal').modal('hide');

            if ( this.emit_guia ) { 
                this.$emit('guia', guia);
                return; 
            }
            
            this.$refs.guia.abrir(guia);
        }, 

        imprimir () { 
            /*
            const configPrint = {
                styles: [
                    "https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css",
                    "https://api.klingo.app/css/estiloa4l.css",
                ]
            };
            */
           
            this.$htmlToPaper("impressao-lancamentos", null, () => {});
        },

        totalizar (lista, campo, flatten = false, filter = false) { 
            if (flatten) { 
                lista = _.flatMap(lista, item => item);
            }

            if ( filter ) { 
                lista = lista.filter(filter);
            }

            return _.sumBy(lista, item => { 
                return parseFloat(item[campo]) || 0; 
            });
        },

        abrir (id_internacao, filtros = {}) {
            this.dados = null; 
            this.unificando_guias = false; 
            this.search_guias = "";

            this.$util.load(this, { 
                service: 'internados', 
                func: 'lancamentos',
                parms: { 
                    id_internacao: id_internacao, 
                    agrupar_cc: this.agrupar_cc, 
                    ...filtros
                },
                loadTo: res => { 
                    this.dados = res; 
                }
            });

            $('#contaModal').modal('show');
        },

        traduzir_tipo (tipo) { 
            switch (tipo) { 
                case 'ATP': return 'Procedimentos'; 
                case 'MAT': return 'Materiais'; 
                case 'MED': return 'Medicamentos'; 
                case 'TXA': return 'Taxas'; 
                default: return tipo; 
            }
        }
    }
}
</script>
